import React from "react";
import {
  CalculatorTabName,
  CALCULATOR_STYLES,
  TAB_SHADOWS,
} from "../constants";

interface TabNavigationProps {
  activeTab: CalculatorTabName;
  onTabClick: (tabName: CalculatorTabName) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  onTabClick,
}) => {
  const getTabStyles = (tabName: CalculatorTabName, isLeft: boolean) => {
    const isActive = activeTab === tabName;
    const positionClass = isLeft
      ? CALCULATOR_STYLES.leftTab
      : CALCULATOR_STYLES.rightTab;
    const activeClass = isActive ? CALCULATOR_STYLES.activeTab : "";

    return {
      className: `${CALCULATOR_STYLES.default} ${positionClass} ${CALCULATOR_STYLES.tabButton} ${activeClass}`,
      style: {
        boxShadow: isActive ? TAB_SHADOWS.active : TAB_SHADOWS.inactive,
      },
    };
  };

  return (
    <div className={CALCULATOR_STYLES.tabContainer}>
      <button
        {...getTabStyles(CalculatorTabName.Simplified, true)}
        onClick={() => onTabClick(CalculatorTabName.Simplified)}
      >
        Simplified
      </button>
      <button
        {...getTabStyles(CalculatorTabName.Detailed, false)}
        onClick={() => onTabClick(CalculatorTabName.Detailed)}
      >
        Detailed
      </button>
    </div>
  );
};

export default TabNavigation;
